import React, { useState, createContext } from 'react';
export const LayoutContext = createContext({});

export const LayoutProvider = ({ children }) => {

    const [sidebarToggle, setSidebarToggle] = useState(false);
    const [profileToggle, setProfileToggle] = useState(false);
    const [menuTitle, setMenuTitle] = useState();
    const onMenuToggle = () => {
        setSidebarToggle(!sidebarToggle);
    };
    const onProfileToggle = () => {
        setProfileToggle(!profileToggle);
    }
    const value = {
        onMenuToggle,
        sidebarToggle,
        menuTitle,
        setMenuTitle,
        profileToggle,
        onProfileToggle,
        setSidebarToggle
    };

    return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};
